const localStorageKey = 'storeeel_targeting_questionnaire_skip';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(localStorageKey) || '{}');
  } catch {
    localStorage.removeItem(localStorageKey);
    return {};
  }
};

const persist = (value) => {
  localStorage.setItem(localStorageKey, JSON.stringify(value));
};

const buildKey = (tenantId) => String(tenantId || 'default');

export const targetingQuestionnaireSkipRepository = {
  get(tenantId) {
    const key = buildKey(tenantId);
    const data = load();
    const entry = data?.[key];

    if (!entry?.TTL || entry.TTL <= Date.now()) {
      if (entry) {
        delete data[key];
        persist(data);
      }
      return false;
    }

    return true;
  },

  set(tenantId) {
    const key = buildKey(tenantId);
    const data = load();
    data[key] = {
      TTL: Date.now() + TTL_MS,
    };
    persist(data);
  },

  removeExpired() {
    const data = load();
    const now = Date.now();
    let updated = false;

    Object.entries(data).forEach(([key, entry]) => {
      if (!entry?.TTL || entry.TTL <= now) {
        delete data[key];
        updated = true;
      }
    });

    if (updated) persist(data);
  },
};
